import { useNavigate } from "react-router-dom";
import { Stack, Box } from "@mui/material";
import {
  useApp,
  useNavigation,
  useService,
  useSession,
  useTheme,
} from "contexts";
import { Common, Custom } from "components";
import { Enums, Routes } from "utils";
import { MessageType, SessionType } from "types";
import { useSignInForm } from "./useSignInForm";
import { Fields } from "./Fields";

type Props = {
  email: string;
  redirect: string;
};

export const Form = ({ email }: Props) => {
  const navigate = useNavigate();
  const { login } = useSession();
  const { userService } = useService();
  const { setFeedback, t } = useApp();
  const { theme } = useTheme();

  const { current, onBlur, onChange, setCurrent } = useSignInForm(email || "");

  async function handleOnSubmit(event: React.FormEvent) {
    event.preventDefault();

    const response = await userService.findByEmailPassword(
      current.email,
      current.password
    );

    if (response) {
      login({
        id: response._id,
        email: response.email,
        name: response.full_name,
        role: response.role,
        settings: response.settings,
      } as SessionType);

      navigate(Routes.userdashboard);
    } else {
      setFeedback({
        message: t.message.feedback.credentials_unmatch,
        severity: Enums.EnumFeedback.Warning,
      } as MessageType);

      setCurrent({ email: current.email, password: "" } as any);
    }
  }

  return (
    <Box component="form" onSubmit={handleOnSubmit} mt={theme.spacing.md}>
      <Stack spacing={theme.spacing.md}>
        <Fields
          current={current}
          onBlur={onBlur}
          onChange={onChange}
          disabledEmail={!!email}
        />
        <Box>
          <Common.Divider sx={{ mb: 0, bgcolor: theme.color.border.accent }} />
        </Box>
        <Stack spacing={theme.spacing.md} textAlign="center">
          <Stack direction="row" spacing={theme.spacing.xs}>
            <Custom.Button
              fullWidth
              variant="contained"
              trailing="right"
              sx={{ mt: theme.spacing.md }}
              submit
            >
              {t.action.sign_in}
            </Custom.Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
